// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gx-0";